import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import useEmirateFromCoordinates, { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common";
import Slider from "react-slick";
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import "../events/Events.css";
import locationPin from "../../assets/events/locationpin.png";
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import circleleftarrow from '../../assets/experience/circleleftarrow.png';
import circlerightarrow from '../../assets/experience/circlerightarrow.png';

import liveconcert from "../../assets/events/liveconcert.png";
import food_dining from "../../assets/events/food_dining.png";
import culture_exhibition from "../../assets/events/culture_exhibition.png";
import sports from "../../assets/events/sports.png";
import kids from "../../assets/events/kids.png";
import networking from "../../assets/events/networking.png";
import communityandsocial from "../../assets/events/communityandsocial.png";
import wellness from "../../assets/events/wellness.png";
import eventsnightlife from "../../assets/events/eventsnightlife.png";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link, useNavigate } from "react-router-dom";
import leftarrow from '../../assets/home-images/right-section-images/leftarrow.png';
import carouselleftarrow from '../../assets/home-images/right-section-images/carouselleftarrow.png';
import carouselrightarrow from '../../assets/home-images/right-section-images/carouselrightarrow.png';

// Debounce utility
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

const Events = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const topEventsRef = useRef(null);
    const sponsorBannerSwiperRef = useRef(null);
    const topBannerSliderRef = useRef(null);
    const [categorybanner, setCategoryBanner] = useState([]);
    const [eventcategory, setEventCategory] = useState([]);
    // Set default coordinates immediately for faster initial load
    const [latitude, setLatitude] = useState(24.4539);
    const [longitude, setLongitude] = useState(54.3773);
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);
    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const [topevents, setTopEvents] = useState([]);
    const [eventlist, setEventList] = useState([]);
    const [sponsorbanner, setSponsorBanner] = useState([]);

    // Loading states for shimmer effects
    const [isCategoryBannerLoading, setIsCategoryBannerLoading] = useState(false);
    const [isTopEventsLoading, setIsTopEventsLoading] = useState(false);
    const [isEventListLoading, setIsEventListLoading] = useState(false);
    const [isSponsorBannerLoading, setIsSponsorBannerLoading] = useState(false);

    // Track touch events for swipe detection on sponsor banner
    const touchStartRef = useRef({ x: 0, y: 0, time: 0 });
    const isSwipeRef = useRef(false);

    // Track touch events for swipe detection on top banner
    const topBannerTouchStartRef = useRef({ x: 0, y: 0, time: 0 });
    const topBannerIsSwipeRef = useRef(false);

    // Get logged in user ID (you may need to adjust this based on your auth system)
    const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id') || null;

    // Dynamically create category mapping from API data
    const categorySectionMapping = useMemo(() => {
        const mapping = [];
        let index = 0;

        // Add all categories from eventcategory API
        if (Array.isArray(eventcategory) && eventcategory.length > 0) {
            eventcategory.forEach((category) => {
                if (category.category_name) {
                    mapping.push({
                        index: index++,
                        categoryName: category.category_name,
                        sectionType: "events"
                    });
                }
            });
        }

        // Insert carousel in the middle (after first half of categories, or after first 3 categories, whichever is smaller)
        const carouselIndex = Math.min(Math.floor(mapping.length / 2), 3);
        mapping.splice(carouselIndex, 0, {
            index: carouselIndex,
            categoryName: null,
            sectionType: "carousel"
        });

        // Update indices after carousel insertion
        mapping.forEach((item, idx) => {
            item.index = idx;
        });

        return mapping;
    }, [eventcategory]);

    // Group events by category with flexible matching
    const eventsByCategory = useMemo(() => {
        const grouped = {};
        if (Array.isArray(eventlist)) {
            eventlist.forEach((event) => {
                const categoryName = event.event_category || event.category_name || event.event_category_name;
                if (categoryName) {
                    // Normalize category name for matching (trim and handle variations)
                    const normalizedName = categoryName.trim();
                    if (!grouped[normalizedName]) {
                        grouped[normalizedName] = [];
                    }
                    grouped[normalizedName].push(event);
                }
            });
            // Debug: Log available categories
            // console.log("Available event categories:", Object.keys(grouped));
        }
        return grouped;
    }, [eventlist]);

    // Helper function to find matching category (case-insensitive, handles variations)
    const findCategoryEvents = (targetCategoryName) => {
        if (!targetCategoryName) return [];
        const normalizedTarget = targetCategoryName.trim().toLowerCase();

        // Create mapping for common variations
        const categoryVariations = {
            "food & dining": ["food & dining", "food and dining", "food & dining experience", "food"],
            "culture & tourism": ["culture & tourism", "culture and tourism", "arts, culture & exhibitions", "culture", "tourism"],
            "live shows & concert": ["live shows & concert", "live shows and concert", "live shows", "concert"],
            "family & kids": ["family & kids", "family and kids", "kids & family", "kids", "family"]
        };

        // First try exact match
        for (const [categoryName, events] of Object.entries(eventsByCategory)) {
            const normalizedCategory = categoryName.toLowerCase();
            if (normalizedCategory === normalizedTarget) {
                return events;
            }
        }

        // Then try partial match
        for (const [categoryName, events] of Object.entries(eventsByCategory)) {
            const normalizedCategory = categoryName.toLowerCase();
            // Check if target contains category or category contains target
            if (normalizedCategory.includes(normalizedTarget) || normalizedTarget.includes(normalizedCategory)) {
                return events;
            }
        }

        // Try variations mapping
        const variations = categoryVariations[normalizedTarget];
        if (variations) {
            for (const [categoryName, events] of Object.entries(eventsByCategory)) {
                const normalizedCategory = categoryName.toLowerCase();
                for (const variation of variations) {
                    if (normalizedCategory.includes(variation) || variation.includes(normalizedCategory)) {
                        return events;
                    }
                }
            }
        }

        return [];
    };

    // Simple helper to get category ID from category name
    const getCategoryId = (categoryName) => {
        if (!categoryName || !Array.isArray(eventcategory)) return null;
        const category = eventcategory.find(
            cat => cat.category_name?.toLowerCase() === categoryName.toLowerCase()
        );
        return category?.id || null;
    };

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Top Banner Arrow Components
    const TopBannerPrevArrow = ({ onClick }) => (
        <div className="top-banner-arrow prev-arrow" onClick={onClick}>
            <img src={carouselleftarrow} alt="Previous" className="top-banner-arrow-icon" />
        </div>
    );

    const TopBannerNextArrow = ({ onClick }) => (
        <div className="top-banner-arrow next-arrow" onClick={onClick}>
            <img src={carouselrightarrow} alt="Next" className="top-banner-arrow-icon" />
        </div>
    );

    // Top Banner Slider Settings
    const sliderSettings = useMemo(() => ({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <TopBannerPrevArrow />,
        nextArrow: <TopBannerNextArrow />,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: false,
        centerMode: !isMobile,
        centerPadding: isMobile ? "0px" : "280px",
        swipe: true,
        touchMove: true,
        draggable: true,
        swipeToSlide: true,
        touchThreshold: 10,
        accessibility: true,
        cssEase: 'ease-in-out',
        useCSS: true,
        useTransform: true,
    }), [isMobile]);

    
    // Category Slider Settings
    const getCategorySlidesToShow = () => {
        const width = window.innerWidth;

        if (width >= 1441) return 4;        // large desktop
        if (width >= 1024) return 3;        // desktop
        if (width >= 769 && width <= 1023) return 3; // tablet - show 3 cards
        if (width >= 320 && width <= 768) return 1.5;  // mobile

        return 1;
    };
    const [categorySlides, setCategorySlides] = useState(getCategorySlidesToShow());

    useEffect(() => {
        const handleResize = debounce(() => {
            setCategorySlides(getCategorySlidesToShow());
        }, 150);

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const PrevArrow = ({ onClick }) => (
        <div className="custom-arrow prev-arrow" onClick={onClick}>
            <img src={leftarrow} alt="Previous" className="event-category-prev-arrow" />
        </div>
    );

    const NextArrow = ({ onClick }) => (
        <div className="custom-arrow next-arrow" onClick={onClick}>
            <img src={rightarrow} alt="Next" className="event-category-next-arrow" />
        </div>
    );


    const categorySliderSettings = useMemo(() => ({
        infinite: false,
        speed: 500,
        slidesToShow: categorySlides,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: categorySlides >= 3, // arrows only on desktop and tablet
        swipeToSlide: true,
        centerMode: false,
        variableWidth: true, // Add this
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    }), [categorySlides]);

    const categoryImagesArray = [
        liveconcert,
        food_dining,
        culture_exhibition,
        sports,
        kids,
        networking,
        communityandsocial,
        wellness,
        eventsnightlife,
    ];

    // Helper function to get category image based on index
    const getCategoryImage = (category, index) => {
        return categoryImagesArray[index % categoryImagesArray.length] || liveconcert;
    };


    // Top Events Slider Settings
    const getTopEventsSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 1300) return 3.5;
        if (width >= 1024) return 3;        // Desktop
        if (width >= 769 && width <= 1023) return 2; // Tablet
        if (width >= 320 && width <= 768) return 1.5; // Mobile

        return 1;
    };
    const [topEventsSlides, setTopEventsSlides] = useState(getTopEventsSlidesToShow());
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1300);

    useEffect(() => {
        const handleResize = debounce(() => {
            setTopEventsSlides(getTopEventsSlidesToShow());
            setIsLargeScreen(window.innerWidth >= 1300);
        }, 150);

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Check if exactly 3 events and screen is 1300px+ (where margin-left is applied)
    const hasExactlyThreeEvents = Array.isArray(topevents) && topevents.length === 3;
    const shouldFixPositioning = hasExactlyThreeEvents && isLargeScreen;

    // Check if less than 3 events (for flex-start alignment) - only for desktop
    const hasLessThanThreeEvents = Array.isArray(topevents) && topevents.length > 0 && topevents.length < 3;
    const shouldApplyFlexStart = hasLessThanThreeEvents && !isMobile;

    const topEventsSettings = useMemo(() => {
        // When exactly 3 events on 1440px+ screens, use 3 slides instead of 3.5 to prevent positioning issues
        const slidesToShow = shouldFixPositioning ? 3 : topEventsSlides;

        // Enhanced mobile settings for screens below 1024px
        const isMobileView = window.innerWidth <= 1024;

        // Disable infinite on mobile, or on desktop when less than 3 events
        const shouldDisableInfinite = isMobileView || hasLessThanThreeEvents;

        return {
            dots: false,
            infinite: !shouldDisableInfinite,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            arrows: false,
            swipeToSlide: true,
            centerMode: false,
            accessibility: true,
            initialSlide: 0, // Always start from the first slide
            // Enhanced mobile touch settings
            touchMove: true,
            swipe: true,
            draggable: true,
            touchThreshold: isMobileView ? 5 : 10, // More sensitive on mobile
            cssEase: 'ease-in-out',
            useCSS: true,
            useTransform: true,
            waitForAnimate: false,
        };
    }, [topEventsSlides, shouldFixPositioning, hasLessThanThreeEvents]);

    // Hide circle arrows if exactly 3 events and all cards fit on screen (desktop only)
    // Calculate actual slidesToShow (after fix) to determine if all cards are visible
    const actualSlidesToShow = shouldFixPositioning ? 3 : topEventsSlides;
    const shouldHideArrows = hasExactlyThreeEvents && !isMobile && actualSlidesToShow >= 3;


    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const [day, month, year] = dateStr.split("-");
        const date = new Date(year, month - 1, day);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };




    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 1441) return 4;
        if (width >= 993 && width <= 1440) return 3;
        if (width >= 320 && width <= 992) return 1.5;
        return 1;
    };
    const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());

    useEffect(() => {
        const handleResize = debounce(() => {
            setSlidesToShow(getSlidesToShow());
        }, 150);

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const unlimitedExperienceSettings = useMemo(() => ({
        infinite: false,
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        initialSlide: 0,
        centerMode: false,
        speed: 500,
        swipeToSlide: false,
        responsive: [],
    }), [slidesToShow]);


    const fetchcategorybanner = async () => {
        const payload = {
            state_id: selectedStateId || emirate?.id || "",
        }

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-category-banner`, payload),
                setIsCategoryBannerLoading,
                (data) => {
                    setCategoryBanner(data);
                }
            );
        } catch (error) {
            console.error("Error fetching Category Banners:", error);
            setCategoryBanner([]);
        }
    }

    const fetcheventcategory = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-event-category`),
                null, // No separate loading state for this individual call
                (data) => {
                    setEventCategory(data);
                }
            );
        } catch (error) {
            console.error("Error fetching Events Category :", error);
            setEventCategory([]);
        }
    }

    const fetchtopevents = async () => {
        const payload = {
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedStateId || emirate?.id || "",
            user_id: "",
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-top-events`, payload),
                setIsTopEventsLoading,
                (data) => {
                    setTopEvents(data);
                }
            );
        } catch (error) {
            console.error("Error fetching Top Events:", error);
            setTopEvents([]);
        }
    }


    const fetcheventlist = async () => {
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedStateId || emirate?.id || "",
            user_id: "",
        };
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-event-list`, payload),
                setIsEventListLoading,
                (data) => {
                    setEventList(data);
                }
            );
        } catch (error) {
            console.error("Error fetching Events List:", error);
            setEventList([]);
        }
    }
    const stateName = eventlist?.[0]?.state_name;

    const fetchsponsorbanner = async () => {
        const payload = {
            state_id: selectedStateId || emirate?.id || "",
        }
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-sponsor-banner`, payload),
                setIsSponsorBannerLoading,
                (data) => {
                    setSponsorBanner(data);
                }
            );
        } catch (error) {
            console.error("Error fetching Sponsor Banners:", error);
            setSponsorBanner([]);
        }
    }

    const fetchMasterData = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-master-data`),
                null, // No separate loading state for this individual call
                (data) => {
                    const stateData = data?.stateData || [];
                    setStates(stateData);
                }
            );
        } catch (error) {
            console.error("Error fetching master data:", error);
            setStates([]);
        }
    }

    const handleStateChange = (state) => {
        setSelectedState(state);
        setSelectedStateId(state.id);

        // Get coordinates from state, with defaults
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        // Store selected state in localStorage
        localStorage.setItem('selectedState', JSON.stringify({
            id: state.id,
            name: state.name,
            latitude: lat,
            longitude: lng
        }));

        // Always update coordinates (use defaults if state doesn't have them)
        setLatitude(lat);
        setLongitude(lng);
    }

    // Check if vendor exists
    const findSelectedProvider = async (vendorId) => {
        if (!vendorId) return false;
        try {
            const response = await fastApiClient.post(`${BACKEND_URL}website/get-vendor-details`, {
                id: vendorId
            });
            const data = response.data;
            return data && (Array.isArray(data) ? data.length > 0 : Object.keys(data).length > 0);
        } catch (error) {
            console.error("Error fetching vendor details:", error);
            return false;
        }
    }

    // Check if event exists
    const setSelectedEventUsingEventId = async (eventId) => {
        if (!eventId) return false;
        try {
            const response = await fastApiClient.post(`${BACKEND_URL}website/get-event-details`, {
                login_user_id: 501,
                event_id: eventId,
            });
            const data = response.data;
            return data && (Array.isArray(data) ? data.length > 0 : Object.keys(data).length > 0);
        } catch (error) {
            console.error("Error fetching event details:", error);
            return false;
        }
    }

    // Check if event_id exists in eventlist
    const isEventIdInEventList = (eventId) => {
        if (!eventId || !Array.isArray(eventlist)) return false;
        return eventlist.some(event => Number(event.event_id) === Number(eventId));
    }

    // Handle event navigation with validation
    const handleEventNavigation = (eventId, e) => {
        if (!isEventIdInEventList(eventId)) {
            e.preventDefault();
            console.log("Event not found in event list");
            alert("This event is not available in the current event list.");
            return false;
        }
        return true;
    }

    // Fetch sponsor banner vendors
    const fetchSponsorBannerVendors = async (bannerId, type = 0) => {
        if (!bannerId) return;
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-sponsor-banner-vendor-list`, {
                    banner_id: bannerId,
                    type: type,
                    login_user_id: 501,
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    console.log("Sponsor Banner Vendors:", data);
                }
            );
        } catch (error) {
            console.error("Error fetching sponsor banner vendors:", error);
        }
    }

    // Fetch sponsor banner events
    const fetchSponsorBannerEvents = async (bannerId, type = 0) => {
        if (!bannerId) return;
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-sponsor-banner-event-list`, {
                    banner_id: bannerId,
                    type: type,
                    login_user_id: 501,
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    console.log("Sponsor Banner Events:", data);
                }
            );
        } catch (error) {
            console.error("Error fetching sponsor banner events:", error);
        }
    }

    // Handle category banner click
    const handleCategoryBannerClick = async (banner) => {
        console.log("Category banner clicked:", banner);
        if (!banner) {
            console.log("No banner data");
            return;
        }

        const isEventList = banner.is_event_list || banner.isEventList;
        const eventId = banner.event_id || banner.eventId;
        const isEventListNum = Number(isEventList);

        console.log("Category banner navigation, is_event_list:", isEventListNum, "event_id:", eventId, "banner.id:", banner.id);

        if (isEventListNum === 1) {
            // Navigate to EventDetails.js - requires event_id
            if (!eventId) {
                console.log("No event_id provided for is_event_list=1, banner is not clickable");
                return;
            }
            console.log("Navigating to event details, event_id:", eventId);
            const isThereAMatchingEvent = await setSelectedEventUsingEventId(eventId);
            console.log("Event exists:", isThereAMatchingEvent);
            if (isThereAMatchingEvent) {
                navigate(`/eventdetails/${eventId}`);
            } else {
                console.log("Event not found");
            }
        } else if (isEventListNum === 2) {
            // Navigate to EventCategoryList.js - uses banner.id, doesn't require event_id
            if (!banner.id) {
                console.log("No banner.id provided for is_event_list=2, banner is not clickable");
                return;
            }
            console.log("Navigating to event category list with banner ID:", banner.id);
            navigate(`/eventcategorylist/${banner.id}?type=categorybanner`);
        } else {
            // If no event_id and is_event_list is not 1 or 2, don't make it clickable
            if (!eventId) {
                console.log("No event_id provided and invalid is_event_list, banner is not clickable");
                return;
            }
            console.log("Invalid is_event_list value:", isEventListNum);
        }
    }

    // Handle banner click based on viewType
    const handleBannerClick = async (banner) => {
        console.log("Banner clicked:", banner);
        if (!banner) {
            console.log("No banner data");
            return;
        }

        // Use snake_case properties from API (view_type, is_vendor_list, etc.)
        const viewType = banner.view_type || banner.viewType;
        const isVendorList = banner.is_vendor_list || banner.isVendorList;
        const isEventList = banner.is_event_list || banner.isEventList;
        const vendorId = banner.vendor_id || banner.vendorId;
        const eventId = banner.event_id || banner.eventId;
        const websiteUrl = banner.website_url || banner.websiteUrl;

        // Log banner properties for debugging
        console.log("Banner properties:", {
            view_type: viewType,
            is_vendor_list: isVendorList,
            is_event_list: isEventList,
            vendor_id: vendorId,
            event_id: eventId,
            id: banner.id,
            website_url: websiteUrl
        });

        if (!viewType) {
            console.log("No view_type found");
            return;
        }

        // Convert viewType to number if it's a string
        const viewTypeNum = Number(viewType);

        switch (viewTypeNum) {
            case 1:
                // Coupon details and coupon list - not implemented
                console.log("ViewType 1 - Coupon (not implemented)");
                break;

            // case 2:
            //     // Vendor-related navigation
            //     const isVendorListNum = Number(isVendorList);
            //     console.log("ViewType 2 - Vendor navigation, is_vendor_list:", isVendorListNum);

            //     if (isVendorListNum === 2) {
            //         // Open vendor list
            //         console.log("Navigating to vendor list");
            //         navigate(`/banners/${banner.id || 0}?type=vendors`);
            //         await fetchSponsorBannerVendors(banner.id || 0, 0);
            //     } else if (isVendorListNum === 1) {
            //         // Open vendor details
            //         console.log("Navigating to vendor details, vendor_id:", vendorId);
            //         if (vendorId) {
            //             // If vendorId matches logged in user, navigate to my account
            //             // Note: Adjust the route based on your app's profile/my account route
            //             if (loggedInUserId && vendorId.toString() === loggedInUserId.toString()) {
            //                 // TODO: Navigate to my account/profile page when route is available
            //                 // For now, navigate to vendor details
            //                 console.log("Navigating to own vendor details");
            //                 navigate(`/vendordetails/${vendorId}`);
            //             } else {
            //                 console.log("Checking if vendor exists...");
            //                 const isThereAVendorProfile = await findSelectedProvider(vendorId);
            //                 console.log("Vendor exists:", isThereAVendorProfile);
            //                 if (isThereAVendorProfile) {
            //                     navigate(`/vendordetails/${vendorId}`);
            //                 } else {
            //                     console.log("Vendor not found");
            //                 }
            //             }
            //         } else {
            //             console.log("No vendor_id provided");
            //         }
            //     } else {
            //         console.log("Invalid is_vendor_list value:", isVendorListNum);
            //     }
            //     break;

            case 3:
                // Event-related navigation
                const isEventListNum = Number(isEventList);
                console.log("ViewType 3 - Event navigation, is_event_list:", isEventListNum);

                if (isEventListNum === 2) {
                    // Open event list
                    console.log("Navigating to event list");
                    navigate(`/eventcategorylist/${banner.id || 0}?type=events`);
                    await fetchSponsorBannerEvents(banner.id || 0, 0);
                } else if (isEventListNum === 1) {
                    // Open event details
                    console.log("Navigating to event details, event_id:", eventId);
                    if (eventId) {
                        const isThereAMatchingEvent = await setSelectedEventUsingEventId(eventId);
                        console.log("Event exists:", isThereAMatchingEvent);
                        if (isThereAMatchingEvent) {
                            navigate(`/eventdetails/${eventId}`);
                        } else {
                            console.log("Event not found");
                        }
                    } else {
                        console.log("No event_id provided");
                    }
                } else {
                    console.log("Invalid is_event_list value:", isEventListNum);
                }
                break;

            case 4:
                // Open website URL
                console.log("ViewType 4 - Opening website URL:", websiteUrl);
                if (websiteUrl) {
                    try {
                        window.open(websiteUrl, '_blank', 'noopener,noreferrer');
                    } catch (error) {
                        console.error("Error opening URL:", error);
                        alert("Unable to open the link. Please check your browser settings.");
                    }
                } else {
                    console.log("No website_url provided");
                }
                break;

            default:
                console.log("Unknown viewType:", viewTypeNum);
                break;
        }
    }

    useEffect(() => {
        // Check for stored state in localStorage first
        const storedState = localStorage.getItem('selectedState');
        if (storedState) {
            try {
                const state = JSON.parse(storedState);
                setSelectedState(state);
                setSelectedStateId(state.id);
                if (state.latitude) {
                    setLatitude(parseFloat(state.latitude));
                } else {
                    setLatitude(24.4539); // Default if no latitude in stored state
                }
                if (state.longitude) {
                    setLongitude(parseFloat(state.longitude));
                } else {
                    setLongitude(54.3773); // Default if no longitude in stored state
                }
            } catch (error) {
                console.error("Error parsing stored state:", error);
                // Set defaults on error
                setLatitude(24.4539);
                setLongitude(54.3773);
            }
        } else {
            // If no stored state, set defaults immediately and try geolocation
            setLatitude(24.4539);
            setLongitude(54.3773);

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLatitude(position.coords.latitude);
                        setLongitude(position.coords.longitude);
                    },
                    (error) => {
                        console.error("Error getting location:", error);
                        // Defaults already set above
                    }
                );
            }
        }
    }, []);

    useEffect(() => {
        fetcheventcategory();
        fetchMasterData();
    }, []);

    // Fetch category and sponsor banners when state_id is available
    useEffect(() => {
        const stateId = selectedStateId || emirate?.id;
        if (stateId) {
            fetchcategorybanner();
            fetchsponsorbanner();
        }
    }, [selectedStateId, emirate]);

    // Center Swiper when sponsor banner data loads or changes
    useEffect(() => {
        if (sponsorBannerSwiperRef.current && sponsorbanner.length > 0) {
            const middleIndex = Math.floor(sponsorbanner.length / 2);
            setTimeout(() => {
                sponsorBannerSwiperRef.current?.slideTo(middleIndex, 0);
            }, 150);
        }
    }, [sponsorbanner]);

    // Call fetchtopevents - coordinates are set immediately with defaults
    useEffect(() => {
        // Coordinates are set immediately with defaults, so this will always run
        fetchtopevents();
        fetcheventlist();
    }, [latitude, longitude, emirate, selectedStateId])

    return (
        <div>
            <Navbar
                selectedState={selectedState}
                onStateChange={handleStateChange}
                states={states}
                showLocationSelector={true}
            />
            <div className="events-left-section">
                <LeftSection
                    selectedState={selectedState}
                    onStateChange={handleStateChange}
                    states={states}
                    showLocationSelector={true}
                    hideVideos={true}
                />
            </div>
            <main className="events-main-layout">
                {/* Top Banner Slider */}
                <div className="events-slider-container">
                    {isCategoryBannerLoading ? (
                        <div className="events-slide">
                            <div className="events-slide-wrapper">
                                <div className="events-slide-image shimmer-image"></div>
                            </div>
                        </div>
                    ) : (
                        <Slider
                            ref={topBannerSliderRef}
                            {...sliderSettings}
                            className="event-banner"
                        >
                            {categorybanner.map((item, index) => {
                                const isEventList = Number(item.is_event_list || item.isEventList || 0);
                                const hasEventId = item.event_id != null;
                                const hasBannerId = item.id != null;
                                // Banner is clickable if:
                                // - is_event_list === 1 AND event_id exists, OR
                                // - is_event_list === 2 AND banner.id exists
                                const isClickable = (isEventList === 1 && hasEventId) || (isEventList === 2 && hasBannerId);

                                return (
                                    <div key={item.id || index} className="events-slide">
                                        <div
                                            className="events-slide-wrapper"
                                            onClick={(e) => {
                                                // Only handle click if it's not a swipe gesture
                                                if (isClickable && !topBannerIsSwipeRef.current) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleCategoryBannerClick(item);
                                                }
                                            }}
                                            onTouchStart={(e) => {
                                                // Track touch start for swipe detection
                                                const touch = e.touches[0];
                                                if (touch) {
                                                    topBannerTouchStartRef.current = {
                                                        x: touch.clientX,
                                                        y: touch.clientY,
                                                        time: Date.now()
                                                    };
                                                    topBannerIsSwipeRef.current = false;
                                                }
                                            }}
                                            onTouchMove={(e) => {
                                                // Detect if user is swiping horizontally
                                                const touch = e.touches[0];
                                                if (touch && topBannerTouchStartRef.current) {
                                                    const deltaX = Math.abs(touch.clientX - topBannerTouchStartRef.current.x);
                                                    const deltaY = Math.abs(touch.clientY - topBannerTouchStartRef.current.y);
                                                    // Mark as swipe if horizontal movement is significant
                                                    if (deltaX > 15 && deltaX > deltaY) {
                                                        topBannerIsSwipeRef.current = true;
                                                    }
                                                }
                                            }}
                                            onTouchEnd={(e) => {
                                                // Only trigger navigation on touch end if it wasn't a swipe
                                                if (isClickable && !topBannerIsSwipeRef.current && topBannerTouchStartRef.current) {
                                                    const touch = e.changedTouches[0];
                                                    if (touch) {
                                                        const deltaX = Math.abs(touch.clientX - topBannerTouchStartRef.current.x);
                                                        const deltaY = Math.abs(touch.clientY - topBannerTouchStartRef.current.y);
                                                        const deltaTime = Date.now() - topBannerTouchStartRef.current.time;

                                                        // Final check: if movement < 10px and time < 300ms, it's a tap
                                                        if (deltaX < 10 && deltaY < 10 && deltaTime < 300) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handleCategoryBannerClick(item);
                                                        }
                                                    }
                                                }
                                                // Reset after touch end
                                                topBannerIsSwipeRef.current = false;
                                                topBannerTouchStartRef.current = { x: 0, y: 0, time: 0 };
                                            }}
                                            style={{ cursor: isClickable ? 'pointer' : 'default' }}
                                        >
                                            {/* VIDEO BANNER - Priority over image */}
                                            {item.banner_video ? (
                                                <video
                                                    key={item.banner_video}
                                                    className="events-slide-image"
                                                    autoPlay
                                                    muted
                                                    loop
                                                    playsInline
                                                    preload="auto"
                                                    onError={(e) => {
                                                        console.error("Video loading error:", e);
                                                        e.target.style.display = 'none';
                                                    }}
                                                >
                                                    <source src={item.banner_video} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                /* IMAGE BANNER - Fallback if no video */
                                                item.banner_image && (
                                                    <img
                                                        src={item.banner_image}
                                                        alt={`Category banner ${index + 1}`}
                                                        className="events-slide-image"
                                                    />
                                                )
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    )}
                </div>

                {/* Categories Carousel */}
                <div className="events-categories-section">
                    <h6 className="events-categories-heading">Categories</h6>
                    <div className="events-categories-slider-container">
                        <Slider
                            key={isMobile ? "mobile-category" : "desktop-category"}
                            {...categorySliderSettings}
                            className="events-categories-carousel"
                        >
                            {eventcategory.map((category, index) => (
                                <Link
                                    to={`/eventcategorylist/${category.id}`}
                                    className="remove-underline"
                                >
                                    <div key={category.id} className="events-category-slide">
                                        <div className="events-category-card">
                                            <div className="events-category-image-wrapper">
                                                <img
                                                    src={getCategoryImage(category, index)}
                                                    alt={category.category_name}
                                                    className="events-category-image"
                                                />
                                            </div>
                                            <p className="events-category-label">
                                                {category.category_name}
                                            </p>
                                        </div>
                                    </div>
                                </Link>

                            ))}
                        </Slider>
                    </div>
                </div>

                {/* Top Events Section */}
                {isTopEventsLoading ? (
                    <div className="top-events-overlay-section">
                        <div className="top-events-overlay-header">
                            <div className="shimmer-line shimmer-title" style={{ width: '150px', height: '24px', margin: '0' }}></div>
                            <div className="circlearrows">
                                <div className="shimmer-circle" style={{ width: '40px', height: '40px', borderRadius: '50%' }}></div>
                                <div className="shimmer-circle" style={{ width: '40px', height: '40px', borderRadius: '50%', marginLeft: '10px' }}></div>
                            </div>
                        </div>
                        <div className="top-events-overlay-carousel-container">
                            <Slider
                                {...topEventsSettings}
                                className="top-events-overlay-carousel"
                            >
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div key={`shimmer-top-${index}`} className="top-events-overlay-slide">
                                        <div className="top-events-overlay-card shimmer-card">
                                            <div className="top-events-overlay-image-wrapper shimmer-image"></div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                ) : Array.isArray(topevents) && topevents.length > 0 && (
                    <div className={`top-events-overlay-section ${shouldFixPositioning ? 'top-events-fix-positioning' : ''} ${shouldApplyFlexStart ? 'top-events-flex-start' : ''}`}>
                        <div className="top-events-overlay-header">
                            <h4 className="top-events-overlay-heading">Top Events</h4>
                            {!shouldHideArrows && (
                                <div className="circlearrows">
                                    <img
                                        src={circleleftarrow}
                                        alt="circleleft"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            topEventsRef.current?.slickPrev();
                                        }}
                                        onTouchEnd={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            topEventsRef.current?.slickPrev();
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <img
                                        src={circlerightarrow}
                                        alt="circleright"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            topEventsRef.current?.slickNext();
                                        }}
                                        onTouchEnd={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            topEventsRef.current?.slickNext();
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="top-events-overlay-carousel-container">
                            <Slider
                                ref={topEventsRef}
                                {...topEventsSettings}
                                className="top-events-overlay-carousel"
                            >
                                {topevents.map((event) => (
                                    <div key={event.id} className="top-events-overlay-slide">
                                        <div className="top-events-overlay-card">
                                            <Link
                                                to={`/eventdetails/${event.event_id}`}
                                                className="remove-underline"
                                                onClick={(e) => handleEventNavigation(event.event_id, e)}>
                                                <div
                                                    className="top-events-overlay-image-wrapper"
                                                    style={{
                                                        backgroundImage: `url(${event.event_image})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat'
                                                    }}
                                                >
                                                    {/* <button
                                                type="button"
                                                className="top-events-overlay-heart-btn"
                                                aria-label="Favorite"
                                            >
                                                <img src={heartIcon} alt="heart" />
                                            </button> */}

                                                    <div className="top-events-overlay-details-overlay">
                                                        <h4 className="top-events-overlay-title">{event.title}</h4>
                                                        <p className="top-events-overlay-location">
                                                            {event.location_name}, {event.state_name}
                                                        </p>
                                                        <p className="top-events-overlay-date">
                                                            {formatDate(event.start_date)} - {formatDate(event.end_date)}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}

                {/* Unlimited Events Abu Dhabi Section */}
                <div className="unlimited-events-section">
                    <Link
                        to={`/eventcategorylist`}
                        className="remove-underline"
                    >
                        <div className="category-names">
                            {stateName && (
                                <>
                                    <h4>All Events in {stateName}</h4>
                                    <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                </>
                            )}

                        </div>
                    </Link>
                    <div className="unlimited-offers-section events-page">
                        {isEventListLoading ? (
                            <Slider {...unlimitedExperienceSettings}>
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div key={`shimmer-all-${index}`} className="offer-card shimmer-card">
                                        <div className="offer-img-wrapper shimmer-image"></div>
                                        <div className="offer-details">
                                            <div className="shimmer-line shimmer-location"></div>
                                            <div className="shimmer-line shimmer-title"></div>
                                            <div className="shimmer-line shimmer-subtitle"></div>
                                            <div className="shimmer-line shimmer-price"></div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <Slider {...unlimitedExperienceSettings}>
                                {eventlist.map((event) => (
                                    <Link
                                        to={`/eventdetails/${event.event_id}`}
                                        className="remove-underline"
                                        onClick={(e) => handleEventNavigation(event.event_id, e)}
                                    >
                                        <div key={event.id} className="offer-card">
                                            <div className="offer-img-wrapper">
                                                <img
                                                    src={event.event_image}
                                                    alt={event.title}
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="offer-details">
                                                <p className="offer-location">
                                                    <img src={locationPin} alt="location" className="locationpinicon" />
                                                    <span>{event.location_name}</span>
                                                </p>
                                                <h4>{event.title}</h4>
                                                <p className="limited-deals-distance">
                                                    {event.start_date === event.end_date
                                                        ? formatDate(event.start_date)
                                                        : `${formatDate(event.start_date)} - ${formatDate(event.end_date)}`}
                                                </p>

                                                {Number(event.price_from) > 0 && (
                                                    <p className="event-list-price">
                                                        {event.price_to != null && <span id="from">From </span>}
                                                        <span>AED {event.price_from}</span>
                                                    </p>
                                                )}

                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </Slider>
                        )}
                    </div>
                </div>

                {/* Dynamic Sections based on category mapping */}
                {categorySectionMapping.map((section) => {
                    if (section.sectionType === "carousel") {
                        // Bottom Image Carousel - use events from first available category or all events
                        // const carouselEvents = eventlist.slice(0, 4); // Take first 4 events for carousel
                        return (
                            <div key={section.index} className="image-carousel-section">
                                <div className="image-carousel-container">
                                    {isSponsorBannerLoading ? (
                                        <Swiper
                                            loop
                                            centeredSlides
                                            autoplay={false}
                                            slidesPerView={isMobile ? 1.3 : 3}
                                            spaceBetween={isMobile ? -11 : -25}
                                            className="image-carousel-swiper"
                                        >
                                            {Array.from({ length: 5 }).map((_, index) => (
                                                <SwiperSlide key={`shimmer-sponsor-${index}`}>
                                                    <div className="image-carousel-card">
                                                        <div className="image-carousel-image-wrapper shimmer-image"></div>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    ) : (
                                        <Swiper
                                            loop
                                            centeredSlides
                                            autoplay={false}
                                            slidesPerView={isMobile ? 1.3 : 3}
                                            spaceBetween={isMobile ? 0 : -25}
                                            onSwiper={(swiper) => {
                                                sponsorBannerSwiperRef.current = swiper;
                                                // Center the slide after initialization
                                                if (sponsorbanner.length > 0) {
                                                    const middleIndex = Math.floor(sponsorbanner.length / 2);
                                                    setTimeout(() => {
                                                        swiper.slideTo(middleIndex, 0); // 0 = no animation
                                                    }, 100);
                                                }
                                            }}
                                            onInit={(swiper) => {
                                                // Ensure centered on init
                                                if (sponsorbanner.length > 0) {
                                                    const middleIndex = Math.floor(sponsorbanner.length / 2);
                                                    swiper.slideTo(middleIndex, 0);
                                                }
                                            }}
                                            initialSlide={sponsorbanner.length > 0 ? Math.floor(sponsorbanner.length / 2) : 0}
                                            className="image-carousel-swiper"
                                        >
                                            {sponsorbanner.map((item) => (
                                                <SwiperSlide key={item.id}>
                                                    <div
                                                        className="image-carousel-card"
                                                        onTouchStart={(e) => {
                                                            // Track touch start position for swipe detection
                                                            const touch = e.touches[0] || e.changedTouches[0];
                                                            if (touch) {
                                                                touchStartRef.current = {
                                                                    x: touch.clientX,
                                                                    y: touch.clientY,
                                                                    time: Date.now()
                                                                };
                                                                isSwipeRef.current = false;
                                                            }
                                                        }}
                                                        onTouchMove={(e) => {
                                                            // Detect if user is swiping horizontally (movement > 15px)
                                                            const touch = e.touches[0] || e.changedTouches[0];
                                                            if (touch && touchStartRef.current) {
                                                                const deltaX = Math.abs(touch.clientX - touchStartRef.current.x);
                                                                const deltaY = Math.abs(touch.clientY - touchStartRef.current.y);
                                                                // Mark as swipe if horizontal movement is significant
                                                                // Allow vertical movement without marking as swipe
                                                                if (deltaX > 15) {
                                                                    isSwipeRef.current = true;
                                                                }
                                                            }
                                                        }}
                                                        onTouchEnd={(e) => {
                                                            // Only trigger navigation on touch end if it wasn't a swipe
                                                            if (!isSwipeRef.current && touchStartRef.current) {
                                                                const touch = e.changedTouches[0];
                                                                if (touch) {
                                                                    const deltaX = Math.abs(touch.clientX - touchStartRef.current.x);
                                                                    const deltaY = Math.abs(touch.clientY - touchStartRef.current.y);
                                                                    const deltaTime = Date.now() - touchStartRef.current.time;

                                                                    // Final check: if movement < 10px and time < 300ms, it's a tap
                                                                    if (deltaX < 10 && deltaY < 10 && deltaTime < 300) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        console.log("Banner card tapped, item:", item);
                                                                        handleBannerClick(item);
                                                                    }
                                                                }
                                                            }
                                                            // Reset after touch end
                                                            isSwipeRef.current = false;
                                                            touchStartRef.current = { x: 0, y: 0, time: 0 };
                                                        }}
                                                        onClick={(e) => {
                                                            // Handle mouse clicks (desktop)
                                                            if (!isSwipeRef.current) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                console.log("Banner card clicked, item:", item);
                                                                handleBannerClick(item);
                                                            }
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div
                                                            className="image-carousel-image-wrapper"
                                                            style={{
                                                                backgroundImage: `url(${item.banner_image})`,
                                                                backgroundSize: "cover",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat",
                                                            }}
                                                        />
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    )}
                                </div>
                            </div>


                        );
                    } else if (section.sectionType === "events" && section.categoryName) {
                        // Event category sections
                        const categoryEvents = findCategoryEvents(section.categoryName);
                        // Debug: Log category matching
                        // if (categoryEvents.length === 0) {
                        //     console.log(`No events found for category: ${section.categoryName}`);
                        // }
                        // Show section even if empty (or return null if you want to hide empty sections)
                        if (categoryEvents.length === 0 && !isEventListLoading) return null;

                        const categoryId = getCategoryId(section.categoryName);
                        return (
                            <div key={section.index} className="unlimited-events-section">
                                <Link
                                    to={categoryId ? `/eventcategorylist/${categoryId}` : `/eventcategorylist`}
                                    className="remove-underline"
                                >
                                    <div className="category-names for-evnts">
                                        <h4>{section.categoryName}</h4>
                                        <img src={rightarrow} alt="rightarrow" className="rightarrow" />
                                    </div>
                                </Link>
                                <div className="unlimited-offers-section events-page">
                                    {isEventListLoading ? (
                                        <Slider {...unlimitedExperienceSettings}>
                                            {Array.from({ length: 4 }).map((_, index) => (
                                                <div key={`shimmer-category-${section.index}-${index}`} className="offer-card shimmer-card">
                                                    <div className="offer-img-wrapper shimmer-image"></div>
                                                    <div className="offer-details">
                                                        <div className="shimmer-line shimmer-location"></div>
                                                        <div className="shimmer-line shimmer-title"></div>
                                                        <div className="shimmer-line shimmer-subtitle"></div>
                                                        <div className="shimmer-line shimmer-price"></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    ) : (
                                        <Slider {...unlimitedExperienceSettings}>
                                            {categoryEvents.map((event) => (
                                                <Link
                                                    to={`/eventdetails/${event.event_id}`}
                                                    className="remove-underline"
                                                    onClick={(e) => handleEventNavigation(event.event_id, e)}
                                                >
                                                    <div key={event.id} className="offer-card">
                                                        <div className="offer-img-wrapper">
                                                            <img
                                                                src={event.event_image}
                                                                alt={event.title}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                        <div className="offer-details">
                                                            <p className="offer-location">
                                                                <img src={locationPin} alt="location" className="locationpinicon" />
                                                                <span>{event.location_name}</span>
                                                            </p>
                                                            <h4>{event.title}</h4>
                                                            <p className="limited-deals-distance">
                                                                {event.start_date === event.end_date
                                                                    ? formatDate(event.start_date)
                                                                    : `${formatDate(event.start_date)} - ${formatDate(event.end_date)}`}
                                                            </p>
                                                            {Number(event.price_from) > 0 && (
                                                                <p className="event-list-price">
                                                                    {event.price_to != null && <span id="from">From </span>}
                                                                    <span>AED {event.price_from}</span>
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Link>

                                            ))}
                                        </Slider>
                                    )}
                                </div>
                            </div>
                        );
                    }
                    return null;
                })}

            </main>
        </div>
    );
};

export default Events;
